import React from "react";
import { ArticleTableData } from "../types";
import { Button, Card, Divider, message, Popconfirm, Popover, Tag } from "antd";
import { CLOUD_URL } from "../../../lib/env";
import { Link, Meta } from "react-router-dom";
import { MdAttachFile, MdEdit, MdNewspaper } from "react-icons/md";
import { TbImageInPicture } from "react-icons/tb";
import { LinkPreview } from "../../../Components/LinkPreview";
import { addToMainNews, deleteArticle, removeFromMainNews } from "../action";
import { CiTrash } from "react-icons/ci";

type Props = {
  articles: ArticleTableData[];
  page: number;
  pageSize: number;
  handleRefresh?: () => void;
};

const ArticleCardViewer = (props: Props) => {
  const { articles, page, pageSize, handleRefresh } = props;
  return (
    <div className="grid grid-cols-4 gap-4">
      {articles.map((article) => (
        <Card
          cover={<img alt="example" src={CLOUD_URL + "/" + article.image} />}
          actions={[
            <Link
              to={`/articles/edit-content/${article.id}?page=${
                page + 1
              }&pageSize=${pageSize}`}
            >
              <Button size="small" type="text">
                <MdEdit />
              </Button>
            </Link>,
            <Link
              to={`/articles/edit-image/${article.id}?page=${
                page + 1
              }&pageSize=${pageSize}`}
            >
              <Button size="small" type="text">
                <TbImageInPicture />
              </Button>
            </Link>,
            <Link
              to={`/articles/manage-attachments/${article.id}?page=${
                page + 1
              }&pageSize=${pageSize}`}
            >
              <Button size="small" type="text">
                <MdAttachFile />
              </Button>
            </Link>,
            <div>
              {!article.onMainNews ? (
                <Popover
                  content={
                    <div className="flex flex-col gap-2">
                      <Button
                        type="text"
                        size="small"
                        onClick={async () => {
                          try {
                            await addToMainNews(article.id, "LARGE");
                            message.success(
                              "Article added to main news as LARGE"
                            );
                            handleRefresh?.();
                          } catch (error) {
                            message.error("Failed to add to main news");
                          }
                        }}
                      >
                        Add as LARGE
                      </Button>
                      <Button
                        type="text"
                        size="small"
                        onClick={async () => {
                          try {
                            await addToMainNews(article.id, "SMALL");
                            message.success(
                              "Article added to main news as SMALL"
                            );
                            handleRefresh?.();
                          } catch (error) {
                            message.error("Failed to add to main news");
                          }
                        }}
                      >
                        Add as SMALL
                      </Button>
                    </div>
                  }
                  title="Add to Main News"
                  trigger="click"
                >
                  <Button type="text" size="small" icon={<MdNewspaper />} />
                </Popover>
              ) : (
                <Popconfirm
                  title="Remove from main news?"
                  onConfirm={async () => {
                    try {
                      await removeFromMainNews(article.id);
                      message.success("Article removed from main news");
                      handleRefresh?.();
                    } catch (error) {
                      message.error("Failed to remove from main news");
                    }
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button size="small" type="text" icon={<MdNewspaper />} />
                </Popconfirm>
              )}
            </div>,
            <Popconfirm
              title="Are you sure to delete this article?"
              onConfirm={() => deleteArticle(article.id)}
              okText="Yes"
              cancelText="No"
            >
              <Button type="text" danger size="small" icon={<CiTrash />} />
            </Popconfirm>,
          ]}
        >
          <h1 className=" text-right font-bold flex flex-row-reverse mb-2 justify-between">
            {article.title}
            <Link
              to={`/articles/edit-main-info/${article.id}?page=${
                page + 1
              }&pageSize=${pageSize}`}
            >
              <Button size="small" type="text">
                <MdEdit />
              </Button>
            </Link>
          </h1>
          <div className="flex  flex-row-reverse items-center justify-between">
            <Tag color="green">{article.category.MainInfo.Title}</Tag>
            <LinkPreview url={article.source_link}>
              {article.source_name}
            </LinkPreview>
          </div>
          <Divider />
          <ul className="flex flex-row-reverse items-center flex-wrap gap-2">
            {article.keywords.map((item) => (
              <Tag color="blue">{item}</Tag>
            ))}
            <Link
              to={`/articles/edit-seo/${article.id}?page=${
                page + 1
              }&pageSize=${pageSize}`}
            >
              <MdEdit />
            </Link>
          </ul>
        </Card>
      ))}
    </div>
  );
};

export default ArticleCardViewer;
